const isDebugLogsEnabled = import.meta.env.DEV;

export const debugLog = (...args: unknown[]): void => {
  if (!isDebugLogsEnabled) return;
  // eslint-disable-next-line no-console
  console.log(...args);
};

export const debugWarn = (...args: unknown[]): void => {
  if (!isDebugLogsEnabled) return;
  // eslint-disable-next-line no-console
  console.warn(...args);
};

export const isDebugEnabled = (): boolean => isDebugLogsEnabled;
